import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { MenuConst } from './constants/menu';
import { Role } from './constants/role';
import { ConfirmDialogComponent } from './material-component/confirm-dialog/confirm-dialog.component';
import { DialogData } from './models/dialog-data';
import { Menu } from './models/menu';
import { User } from './models/user';
import { ApplicationService } from './services/application.service';
import { DashboardService } from './services/dashboard/dashboard.service';
import { NotificationService } from './services/notification/notification.service';
import { TokenStorageService } from './services/token-storage/token-storage.service';
import { UserService } from './services/user/user.service';
import { ChangePasswordComponent } from './change-password/change-password.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;
  menus: Menu[] = [];
  user: User | undefined;

  onDestroy$ = new Subject<void>();

  MenuConst = MenuConst;

  PEGAWAI_MENUS = [
    MenuConst.DASHBOARD,
    MenuConst.PROFILE,
    MenuConst.RIWAYAT_PROFILE,
    MenuConst.CUTI,
    MenuConst.NOTIFICATION,
    MenuConst.REGULASI,
  ];

  ADMIN_KEPEGAWAIAN_MENUS = [
    MenuConst.DASHBOARD,
    MenuConst.PROFILE,
    MenuConst.CUTI,
    MenuConst.NOTIFICATION,
    MenuConst.REGULASI,
    MenuConst.USER,
    MenuConst.ALARM_PEGAWAI,
    MenuConst.FORMASI_KEPEGAWAIAN,
  ];

  ADMIN_CUTI_MENUS = [
    MenuConst.DASHBOARD,
    MenuConst.PROFILE,
    MenuConst.CUTI,
    MenuConst.NOTIFICATION,
    MenuConst.REGULASI,
    MenuConst.APPROVAL_CUTI,
  ];

  constructor(
    public dashboardService: DashboardService,
    public notificationService: NotificationService,
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private dialog: MatDialog,
    private userService: UserService,
    private applicationService: ApplicationService,
  ) { }

  ngOnInit(): void {
    this.applicationService.init();
    this.user = this.tokenStorageService.getUser();
    this.notificationService.fetchUnreadCount();

    this.router.events
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.userService.checkToken().subscribe();
        }
      });

    this.applicationService.lockScreen$
      .pipe(debounceTime(300), takeUntil(this.onDestroy$))
      .subscribe((isLockScreen: any) => {
        if (isLockScreen) {
          this.displayLockScreen();
        }
      });

    this.applicationService.displayError$
      .pipe(debounceTime(300), takeUntil(this.onDestroy$))
      .subscribe((displayError: any) => {
        if (displayError) {
          this.displayError();
        }
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  displayError() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: "Galat",
        message: "Terjadi kesalahan...",
        okLabel: "Refresh",
        isConfirmation: true,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        window.location.reload();
      }
    });
  }

  displayLockScreen() {
    // const dialogRef = this.dialog.open(LockScreenComponent, {
    //   disableClose: true,
    //   panelClass: 'full-width-dialog',
    // });
    // dialogRef.afterClosed().subscribe((result: any) => {
    //   if (result) {
    //   }
    // });
  }

  ngAfterViewInit() {
    // this.observer
    //   .observe(['(max-width: 800px)'])
    //   .pipe(delay(1))
    //   .subscribe((res: { matches: any; }) => {
    //     this.isSmallScreen$.next(res.matches);
    //   });
  }

  isVisible(menuId: number) {
    const roles = this.user?.userRoles;
    return roles
      ?.map((role: { roleId: any; }) => role.roleId)
      .some(
        (roleId: number) =>
          roleId === Role.SUPERADMIN ||
          (roleId === Role.PNS && this.PEGAWAI_MENUS.includes(menuId)) ||
          (roleId === Role.ADMIN_KEPEGAWAIAN && this.ADMIN_KEPEGAWAIAN_MENUS.includes(menuId)) ||
          (roleId === Role.ADMIN_CUTI && this.ADMIN_CUTI_MENUS.includes(menuId)) ||
          (roleId === Role.NON_PNS && this.PEGAWAI_MENUS.includes(menuId))
      );
  }

  trackByIdentity(index: number, item: any) {
    return item;
  }

  goToLink(url: string) {
    window.open(url, "_blank");
  }

  public openChangePasswordDialog() {
    this.dialog.open(ChangePasswordComponent, {
      disableClose: true,
    });
  }
}

